import { Form } from '@ant-design/compatible';
import { Button } from 'antd';
import { withFormik } from 'formik';
import React from 'react';

import { EnumFormSelect, FORM_ITEM_DEFAULT_LAYOUT, TextField } from '../../../pages/ModelForm/form-fields';
import { ModelFormSelect } from '../../../pages/ModelForm/ModelFormSelect';
import { PropertyModel } from '../../Property/model';

import {
  handleSubmit,
  IEmergencyScenarioFormProps,
  IEmergencyScenarioFormValues,
  mapPropsToValues,
  validate,
} from './formik';

export const EmergencyScenarioForm = withFormik<IEmergencyScenarioFormProps, IEmergencyScenarioFormValues>({
  mapPropsToValues,
  validate,
  handleSubmit,
  enableReinitialize: true,
  validateOnChange: false,
  validateOnBlur: false,
})((props) => {
  const { isNew, values, setFieldValue, isSubmitting, onCancel, resetForm } = props;

  const handleCancelClick = () => {
    onCancel();
    resetForm();
  };

  return (
    <Form onSubmit={props.handleSubmit}>
      {isNew && (
        <ModelFormSelect
          fieldName='propertyId'
          formItemProps={{ ...FORM_ITEM_DEFAULT_LAYOUT }}
          modelSelectProps={{
            value: values.propertyId,
            model: PropertyModel,
            required: true,
            autoSelectSingleResult: true,
          }}
          setFieldValue={setFieldValue}
          errors={props.errors}
          submitCount={props.submitCount}
        />
      )}
      <TextField
        {...props}
        required
        isNew
        field={{
          name: 'name',
          required: true,
          scalarName: 'string',
        }}
        maxLength={50}
      />
      {!isNew && (
        <EnumFormSelect
          enumSelectProps={{
            value: values.status,
            enumTable: 'EmergencyScenarioStatus',
            onChange: (nextValue) => {
              setFieldValue('status', nextValue || null, true);
            },
          }}
          formItemProps={{
            ...props,
            isNew,
            field: {
              name: 'status',
              required: false,
              scalarName: '',
            },
            help: (
              <div className='help-text'>
                "Testing" mode will <strong>fully activate</strong> the emergency scenario,
                but residents will <strong>NOT</strong> be notified via the app banner.
              </div>
            ),
          }}
        />
      )}
      <section style={{ marginTop: 50, display: 'flex', justifyContent: 'center' }}>
        <Button
          type='primary'
          htmlType='submit'
          loading={isSubmitting}
          disabled={isSubmitting}
          style={{ marginRight: 10 }}
        >
          {isSubmitting ? 'Saving' : 'Save'}
        </Button>
        <Button onClick={handleCancelClick} loading={isSubmitting} disabled={isSubmitting}>
          Cancel
        </Button>
      </section>
    </Form>
  );
});
